import { useEffect } from "react";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestList from "./components/LatestList";
import FeaturedInsight from "./components/FeaturedInsight";
import SidebarHot from "./components/SidebarHot";

export default function Home() {
  useEffect(() => {
    document.title = "迷人的保姆 - 最新电视剧全集剧情介绍与精彩片段";
  }, []);

  return (
    <div className="flex flex-col">
      <HeroCarousel />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 lg:px-8">
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            迷人的保姆 · 影视剧集资讯站
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600">
            这里汇集了电视剧《迷人的保姆》的全集介绍、剧情解析、角色说明与精彩片段回顾，并收录了大量同类题材的优质剧集。
            无论你想重温剧情细节，还是寻找下一部值得追的好剧，都能在这里找到答案。
          </p>
          <div className="mt-5 flex flex-wrap gap-6">
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-file-list-3-line text-primary-500"></i>
              收录 12 部剧集
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-stack-line text-primary-500"></i>
              共 78 集剧情介绍
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-bookmark-3-line text-primary-500"></i>
              3 大主题专题
            </div>
          </div>
        </div>
      </section>

      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-5 px-4 py-8 md:px-6 lg:grid-cols-3 lg:px-8">
        <div className="flex flex-col gap-5 lg:col-span-2">
          <CategoryEntry />
          <LatestList />
          <FeaturedInsight />
        </div>
        <aside className="lg:col-span-1">
          <SidebarHot />
        </aside>
      </div>
    </div>
  );
}